import { UiText } from '@experiences/ui-common';
import { UiStorage } from '@experiences/util';
import { makeStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import { ApProgressSpinner } from '@uipath/portal-shell-react';
import React, {
    useEffect,
    useState,
} from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router';

export interface IGrantConsentMessage {
    grantConsentState: string | null;
    grantConsentAuthCode?: string | null;
    grantConsentError?: string | null;
    grantConsentAdmin?: boolean;
    grantConsentTenant?: string | null;
}

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            display: 'flex',
            justifyContent: 'center',
            margin: 'auto',
        },
    }),
);

export const GrantConsent: React.FC = () => {
    const { formatMessage: translate } = useIntl();
    const classes = useStyles();
    const location = useLocation();

    const [ error, setError ] = useState<string>();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const paramError = params.get('error');
        const code = params.get('code');
        const adminConsent = params.get('admin_consent') === 'True';
        const tenant = params.get('tenant');
        const returnedState = params.get('state');

        // Verify the state parameter
        const storedState = UiStorage.getItem('oauth_state');
        if (storedState && returnedState !== storedState) {
            setError(translate({ id: 'CLIENT_STATE_PARAMETER_MISMATCH' }));
            return;
        }

        // Clear the stored state
        UiStorage.removeItem('oauth_state');

        if (code || paramError || adminConsent) {
            window.opener.postMessage({
                grantConsentState: returnedState,
                grantConsentAuthCode: code,
                grantConsentError: paramError,
                grantConsentAdmin: adminConsent,
                grantConsentTenant: tenant,
            }, window.origin);

            window.close();
        }
    }, [ location.search, translate ]);

    return (
        <div className={classes.root}>
            {!error && <ApProgressSpinner data-cy="grant-consent-spinner" />}
            {error && <UiText
                color="error"
                data-cy="grant-consent-error">
                {error}
            </UiText>}
        </div>
    );
};
